module.exports = __webpack_public_path__ + "media/images/lb/422-e49be3184abdb9e2994d47756428c466.svg";